export enum ServiceCounter{
    SERVICE  =   "S",
    COUNTER  =   "C"
}